/**
 * Created by lxhfight on 2018/4/3.
 * Email: lxhfight1@gmail.com
 * Description:
 *    提供各种和HTTP請求相關的工具方法
 */

export const errorCode = {
  USER_RESTRICTION_OLD: 215,
  USER_RESTRICTION_DISABLE: 276,
  USER_RESTRICTION_INVESTIGATE: 277,
  USER_NOT_FOUND: 200,
  // 蘿蔔點數不足（同後端 Error::ERROR_NO_ENOUGH_MONEY）
  NO_ENOUGH_MONEY: 5057
}

export const errorMap = (str) => {
  switch (str) {
    case 'PASSWORD_ERROR':
      return '會員密碼錯誤'
    case 'EMAIL_NOT_EXISTS':
      return '該信箱不存在，請重新輸入'
    case 'SIGNUP_EMAIL_EXISTS':
      return '註冊信箱已存在'
    case 'INVAILD_TOKEN':
      return '請重新登入'
    case 'LOGIN_BEFORE_ACTION':
      return '請先登入/註冊會員'
    case 'FULLFIL_IN_BEFORE_ACTION':
      return '請先完善會員基本資料'
    case 'PHONE_NOT_FOUND':
      return '手機號未註冊'
    case 'NO_VERIFICATION_CODE':
      return '無效的驗證碼'
    case 'PASSWORD_NOT_SAME':
      return '兩次密碼輸入不一致'
    case 'CELLPHONE_HAS_BEEN_TAKEN':
      return '手機已被註冊或綁定'
    case 'PHONE_VERIFICATION_WRONG':
      return '手機驗證碼錯誤'
    case 'INVALID_INVITE_CODE':
      return 'GC代贈綁定碼錯誤'
    case 'PASSWORD_UNCHANGED':
      return '新密碼不能與上次密碼相同'
    case 'TOKEN_INVALID':
      return '請先登入'
    case 'LOGIN_TYPE_ERROR':
      return '請使用您註冊的方式登入'
    case 'EC_DATA_FORMAT_WRONG':
      return '掌櫃訂單數據異常'
    case 'NOT_FOUND_CABINETS':
      return '當前地區暫未提供掌櫃服務'
    case 'GIFT_NOT_FOUND':
      return '禮物不存在'
    case 'NEED_NOT_FOUND':
      return '需求不存在'
    case 'TOKEN_EXPIRED':
      return '登入過期，請重新登入'
    case 'GIFT_LEFT_NOT_ENOUGH':
      return '禮物剩餘數量不足'
    case 'REPEATED_ADDITION':
      return '您已參與本次活動，不可重複參與，去給喜歡的作品送愛心吧~'
    case 'GIFT_HAS_BEEN_DELETED':
      return '抱歉，此礼物您無法瀏覽...'
    case 'NEED_HAS_BEEN_DELETED':
      return '抱歉，此需求您無法瀏覽...'
    case 'EDCODE_IS_NULL':
      return '請求錯誤，掌櫃櫃機信息不完整'
    case 'GIVER_SENT_AT_IS_NULL':
      return '請選擇新竹物流上門取件日期'
    case 'CANT_LOGIN_BECAUSE_EMAIL_USED':
      return '請使用您註冊時選擇的方式登入網站哦～'
    case 'CANT_LOGIN_BECAUSE_EMAIL_USED_BY_FACEBOOK_LOGIN':
      return '您的帳號為FB註冊方式，請使用FB登入'
    case 'CANT_LOGIN_BECAUSE_EMAIL_USED_BY_GOOGLE_LOGIN':
      return '您的帳號為G+註冊方式，請使用G+登入'
    case 'CANT_LOGIN_BECAUSE_EMAIL_USED_BY_EMAIL_LOGIN':
      return '您的帳號為信箱註冊方式，請使用信箱密碼登入'
    case 'EMAIL_TOKEN_EXPIRED':
      return '連結已過期，請重新發送'
    case 'CAN_NOT_ADD_TO_CART_NO_THANK':
      return '您索取過的GC代贈還沒留下感謝話語，請感謝後再來索取吧~'
    case 'NO_ENOUGH_PROVISIONS':
      return '物品庫存不足，無法加入禮物車'
    case 'CAN_NOT_ADD_TO_CART':
      return 'GC代贈上架5天內，限定公益團體/學校單位索取，之後開放全站索取~'
    case 'CANT_FIND_PASSWORD_BY_EMAIL_BECAUSE_TYPES_FACEBOOK':
      return '您的帳號使用Facebook登入方式，請在登入界面選擇Facebook登入'
    case 'CANT_FIND_PASSWORD_BY_EMAIL_BECAUSE_TYPES_GOOGLE':
      return '您的帳號使用Google+登入方式，請在登入界面選擇Google+登入'
    case 'CANT_FIND_PASSWORD_BY_EMAIL_BECAUSE_TYPES_PHONE':
      return '您的帳號使用手機註冊，請輸入手機號碼找回密碼'
    case 'ACCESS_DENY':
      return '無權操作'
    case 'NOT_VERIFY':
      return '完成手機快捷驗證，可參加活動及贈送索取物品'
    case 'PARAMS_MISSING':
      return '問卷資料不完整，請確認必填項目'
    case 'SURVEY_NOT_FOUND':
      return '問卷不存在或已下線'
  }
  return str
}
